import { Schema } from "effect";
import { AccountId, ShopperAiIntegrationId } from "../../../ids/definitions";
import { IntegrationChannelData } from "./channel-data";

export const SHOPPER_AI_INTEGRATION_TYPES = [
  "gmail",
  "outlook",
  "instagram",
  "facebook",
  "tiktok",
  "attentive",
  "postscript",
  "redoChatAi",
  "redoChatFlow",
  "redoChatLive",
] as const;
export const ShopperAiIntegrationType = Schema.Literal(
  ...SHOPPER_AI_INTEGRATION_TYPES,
);
export type ShopperAiIntegrationType = typeof ShopperAiIntegrationType.Type;

// Response schema for integration with channel data
export const IntegrationWithChannelDataResponse = Schema.Struct({
  id: ShopperAiIntegrationId,
  accountId: AccountId,
  integrationType: ShopperAiIntegrationType,
  permissionsRevoked: Schema.Boolean,
  channelData: Schema.NullOr(IntegrationChannelData),
});
export type IntegrationWithChannelDataResponse =
  typeof IntegrationWithChannelDataResponse.Type;

export const IntegrationCursor = Schema.Struct({ id: ShopperAiIntegrationId });
export type IntegrationCursor = typeof IntegrationCursor.Type;
